module.exports = __webpack_public_path__ + "static/media/pool.6fb8f5b1.svg";